import { isThemeUpsellValid, isTimerExpired } from "@/Utils/common";
import React, { useSelector } from "react-redux";
import { RootState } from "../../Redux/Reducers";
import { useCountdownHook } from "../../Utils/countdownTimerHook";
import { getDLPThemeUpsellDiscount } from "../DomainSalesSearch/utils/common";

const ThemeUpsellBanner = () => {
  const { bannerInfo } = useSelector((state: RootState) => ({
    bannerInfo: state.staffManagementReducer?.staffMemberData?.banner_info,
  }));

  const [hour, minute, second] = useCountdownHook(bannerInfo?.expiry_time || "");

  if (!bannerInfo?.expiry_time || !isThemeUpsellValid() || isTimerExpired(hour, minute, second)) {
    return null;
  }

  return (
    <div className="tw-z-[9999] tw-flex tw-max-h-[48px] tw-w-full tw-items-center tw-justify-center tw-gap-3 tw-overflow-hidden tw-bg-[#DAEDEA] tw-py-[14px] tw-text-[14px] tw-text-[#1E6A26]">
      <section>
        <span className="tw-font-extrabold">GET ₹{getDLPThemeUpsellDiscount()} off</span>{" "}
        <span className="tw-font-medium">on your favourite, professionally-designed websites. Offer ends in</span>
      </section>
      <div className="tw-rounded tw-bg-[#1E6A26] tw-px-[14px] tw-py-[4px] tw-text-white">
        {hour !== "00" && 
          <span className="tw-font-bold">
            {hour}
            <span className="tw-font-normal">h </span>:
          </span>
        }
        <span className="tw-font-bold">
          {" "}
          {minute}
          <span className="tw-font-normal">m </span>:
        </span>
        <span className="tw-font-bold">
          {" "}
          {second}
          <span className="tw-font-normal">s </span>
        </span>
      </div>
    </div>
  );
};

export default ThemeUpsellBanner;
